
export const PRIVATE_DRIVE_API = {
  STORAGE_CONFIG: '/api/pluginstorage/',
  RSA_PUBLIC_KEY: '/api/pluginstorage/rsa/',
  GET_FILES: '/api/pluginstorage/list/',
  DOWNLOAD_FILE: '/api/pluginstorage/download/',
  UPLOAD_FILE: '/api/pluginstorage/upload/',
};
